import { CrudOptions, restrictApi, useCrud } from '@wyz/utils';
import { IAdvert, IAdvertPayload } from '~/connect/types';
import { useApi, useConfig } from '~/common/context';
import { ConnectQueryKeys } from '~/connect/api';
import { IErrorApiResponse, IValidationError } from '@wyz/types';
import { CommonErrorCodesEnumType } from '~/common/types';

type Actions = 'create' | 'update' | 'remove' | 'getOneById';

type Options = Pick<
  CrudOptions<
    IAdvert,
    IAdvertPayload,
    IAdvertPayload,
    IErrorApiResponse<
      IValidationError<CommonErrorCodesEnumType>,
      CommonErrorCodesEnumType
    >
  >,
  Actions
>;

export const useManageAdverts = <
  TRequestedKeys extends keyof Options,
  TRequestedOptions extends Options = Pick<Options, TRequestedKeys>,
>(
  options: TRequestedOptions,
) => {
  const { callCoreApi } = useApi();
  const { tenantCode } = useConfig();

  const api = useCrud<
    Actions,
    IAdvert,
    IAdvertPayload,
    IAdvertPayload,
    IErrorApiResponse<
      IValidationError<CommonErrorCodesEnumType>,
      CommonErrorCodesEnumType
    >
  >(
    {
      baseKey: ConnectQueryKeys.adverts.base(tenantCode),
      caller: callCoreApi,
      endpoint: `/tenants/api/wtb/tenants/${tenantCode}/adverts`,
    },
    {
      ...options,
    },
  );

  return restrictApi(options, api);
};
